import React from 'react';

import { capitalize } from 'utils';

import { ReactComponent as FileIcon } from 'pages/Teachers/StudentDetail/assets/file.svg';
import { ReactComponent as PersonIcon } from 'pages/Teachers/StudentDetail/assets/person.svg';

import styles from './styles.module.scss';

const StudentSubtitle = ({ studentName, sectionLabel }) => {
  if (!studentName && !sectionLabel) return null;

  return (
    <div className={styles.navSubtitleContainer}>
      {studentName && (
        <div className={styles.navSubtitleGroup}>
          <PersonIcon className={styles.navSubtitleIcon} />
          <span className={styles.studentNameText}>
            {capitalize({ str: studentName })}
          </span>
        </div>
      )}
      {sectionLabel && (
        <div className={styles.navSubtitleGroup}>
          <FileIcon className={styles.navSubtitleIcon} />
          <span className={styles.sectionLabelText}>{sectionLabel}</span>
        </div>
      )}
    </div>
  );
};

export default StudentSubtitle;
